import axios from 'axios';
import settings from 'settings';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class TravelApi {
  // Travel Modes API ------
  static getAllTravelModes(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.travelModeList, { params });
  }

  // Travel Location API ------
  static getAllLocations(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.travelLocationList, { params });
  }

  static getLocation({ id }) {
    return axios.get(ApiEndpoints.travelLocation.replace(':id:', id));
  }

  static createLocation(params) {
    return axios.post(ApiEndpoints.travelLocationList, params);
  }

  static updateLocation(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.travelLocation.replace(':id:', id), data);
  }

  static deleteLocation({ id }) {
    return axios.delete(ApiEndpoints.travelLocation.replace(':id:', id));
  }

  // Travel Route Types API ------
  static getAllRouteTypes(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    params.default_value = `name__${settings.APP_CONFIG.defaultRouteType}`;
    return axios.get(ApiEndpoints.travelRouteTypeList, { params });
  }

  static getRouteType({ id }) {
    const url = ApiEndpoints.travelRouteType.replace(':id:', id);
    return axios.get(url);
  }

  static createRouteType(tr) {
    return axios.post(ApiEndpoints.travelRouteTypeList, tr);
  }

  static updateRouteType(id, tr) {
    return axios.patch(ApiEndpoints.travelRouteType.replace(':id:', id), tr);
  }

  static deleteRouteType({ id }) {
    return axios.delete(ApiEndpoints.travelRouteType.replace(':id:', id));
  }

  // Travel Route API
  static getAllRoutes(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.travelRouteList, { params });
  }

  static getRoute({ id }) {
    return axios.get(ApiEndpoints.travelRoute.replace(':id:', id));
  }

  static createRoute(params) {
    return axios.post(ApiEndpoints.travelRouteList, params);
  }

  static updateRoute(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.travelRoute.replace(':id:', id), data);
  }

  static deleteRoute({ id }) {
    return axios.delete(ApiEndpoints.travelRoute.replace(':id:', id));
  }

  // Travel Legs Types API ------
  static getAllLegs(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.travelLegList, { params });
  }

  static getLeg({ id }) {
    return axios.get(ApiEndpoints.travelLeg.replace(':id:', id));
  }

  static createLeg(params) {
    return axios.post(ApiEndpoints.travelLegList, params);
  }

  static updateLeg(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.travelLeg.replace(':id:', id), data);
  }

  static deleteLeg({ id }) {
    return axios.delete(ApiEndpoints.travelLeg.replace(':id:', id));
  }

  // ------ Bookings API ------
  static getAllBookings(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);

    return axios.get(ApiEndpoints.travelBookingList, { params });
  }

  static getBooking({ id }) {
    return axios.get(ApiEndpoints.travelBooking.replace(':id:', id));
  }

  static createBooking(params) {
    return axios.post(ApiEndpoints.travelBookingList, params);
  }

  static updateBooking(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.travelBooking.replace(':id:', id), data);
  }

  static deleteBooking({ id }) {
    return axios.delete(ApiEndpoints.travelBooking.replace(':id:', id));
  }

  // ------ Booking Status API ------
  static getBookingHistory({ id }) {
    return axios.get(ApiEndpoints.travelBookingHistory.replace(':id:', id));
  }

  static getAllBookingStatuses(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.travelBookingStatusList, { params });
  }

  static bulkUpdateBookingStatus(b_ids, s_id) {
    return axios.patch(ApiEndpoints.travelBookingBulkStatus, {
      newStatusId: s_id,
      bookingIds: b_ids
    });
  }

  // ------ Itinery API ------
  static getAllItineraries(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.travelItineraryList, { params });
  }

  static getItinerary({ id }) {
    return axios.get(ApiEndpoints.travelItinerary.replace(':id:', id));
  }

  static createItinerary(itinerary) {
    return axios.post(ApiEndpoints.travelItineraryList, itinerary);
  }

  static updateItinerary(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.travelItinerary.replace(':id:', id), data);
  }

  static deleteItinerary({ id }) {
    return axios.delete(ApiEndpoints.travelItinerary.replace(':id:', id));
  }

  static addItineraryBooking(id, params) {
    return axios.post(ApiEndpoints.travelItineraryBooking.replace(':id:', id), params);
  }

  // Links API
  static getAllLinks() {
    return axios.get(ApiEndpoints.travelLinksList);
  }

  static createLink(tl) {
    return axios.post(ApiEndpoints.travelLinksList, tl);
  }

  static deleteLink({ id }) {
    return axios.delete(ApiEndpoints.travelLink.replace(':id:', id));
  }
}

export default TravelApi;
